
import '../css/Projects.css'

const projects = [
    {
        name: 'Broadcast',
        description: 'This is a multichannel message sending platform with fallback mechanism by different channels Like:- SMS, RCS, WHATSAPP, MI'
    },
    {
        name: 'Whatsapp on Cloud',
        description: 'This is a platform where a Business can campaign to end user on whatsapp.'
    },
    {
        name: 'Helo SMS',
        description: 'The Helo SMS project is used by Business to do campaign or Authientication over phone as SMS message. '
    },
    {
        name: 'Helo RCS',
        description: 'The Helo RCS project which is used by Business to send messages on Android phone or RCS enable phone.'
    },
    {
        name: 'Helo MI',
        description: 'The Helo MI channel is to send the message to target audience which has MI phone.'
    },
    {
        name: 'Url Shortner',
        description: 'The Url shortner project is responsible to create shortlink by using longUrl and this shortLink is used while sending message and it rdirects to respective longUrl.'
    }
]


const Projects = () => {
    return (
        <section className="projects-section">
            <h2> Projects </h2>
            <div className='project-container'>
                {projects.map((eachProject) => (
                    <div className='project'>
                        <h2>{eachProject.name}</h2>
                        <p>{eachProject.description}</p>
                        <button className='project-button'>Know more</button>
                    </div>
                ))}


            </div>
        </section>
    )
}

export default Projects